const news = (Vue, request) => {
	//列表
	Vue.prototype.getNewsListApi = (data) => {
		return request({
			url: '/web-api/news',
			params:{
				limit:1000,
				flag: 1,
			},
			method: 'get',
		})
	}
	//详情
	Vue.prototype.getNewsInfoApi = (id) => {
		return request({
			url: `/web-api/news/${id}`,
			method: 'get',
		})
	}
}
export default news
